import { useEffect } from 'react';
import { addHours } from 'date-fns';
import queryString from 'query-string';

const CookieDomain =
  window.location.hostname.endsWith('dineout.is') ? '.dineout.is' : 'localhost';

export const useBookingReferrer = () => {
  const { do_referrer } = queryString.parse(window.location.search);

  useEffect(() => {
    const setReferrerCookie = (referrerCode: string) => {
      const now = new Date();
      const expires = addHours(now, 2);
      window.document.cookie =
        'do_referrer=' +
        referrerCode +
        ';domain=' +
        CookieDomain +
        ';expires=' +
        expires.toString();
    };

    const referrerCode = do_referrer as string | undefined;

    if (referrerCode) {
      setReferrerCookie(referrerCode.toString());
    }
    /* eslint-disable */
  }, []);
};
